import { render, staticRenderFns } from "./ScaleBased.vue?vue&type=template&id=404d1f6c&scoped=true"
import script from "./ScaleBased.vue?vue&type=script&lang=js"
export * from "./ScaleBased.vue?vue&type=script&lang=js"
import style0 from "./ScaleBased.vue?vue&type=style&index=0&id=404d1f6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404d1f6c",
  null
  
)

export default component.exports